import axiosService from "./axios-service";

export const getPlans = async (plan = "all") => {
  return axiosService.get(`/sales/incentive/fetch_plan?plan=${plan}`);
};

export const addPlan = async (data) => {
  return axiosService.post(`/sales/incentive/upsert_plan`, data);
};

export const uploadPlanFile = (data) => {
  return axiosService.post(`/sales/incentive/v2/upsert_plan`, data);
};
